import { render } from "./dropZone1.vue?vue&type=template&id=502f96a8"
import script from "./dropZone1.vue?vue&type=script&lang=js"
export * from "./dropZone1.vue?vue&type=script&lang=js"

import "./dropZone1.vue?vue&type=style&index=0&id=502f96a8&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__